import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { Mic, BookMarked, PenLine, MessageSquareQuote, ArrowRight, Crown } from "lucide-react";

const AGENT_ICONS = { speaking_coach: Mic, vocabulary_coach: BookMarked, sentence_builder: PenLine, point_of_view: MessageSquareQuote };

export default function Coaches() {
  const [agents, setAgents] = useState([]);
  const [access, setAccess] = useState(null);

  useEffect(() => {
    api.get("/agents").then((r) => { setAgents(r.data.agents); setAccess(r.data.access); }).catch((e) => console.error("Failed to load coaches", e));
  }, []);

  return (
    <div data-testid="coaches-page">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="font-display text-4xl font-semibold">AI Coaches</h1>
          <p className="text-muted-foreground mt-2">Four specialists in warm Hinglish. Pick one and start practising.</p>
        </div>
        {access && !access.is_premium && (
          <div className="text-sm">
            {access.trial_active ? <span className="px-3 py-1.5 rounded-full bg-accent text-accent-foreground font-semibold">Free trial active</span>
              : access.trial_started ? <Link to="/premium" className="px-3 py-1.5 rounded-full bg-primary text-primary-foreground font-semibold inline-flex items-center gap-1"><Crown className="h-4 w-4" /> Go Premium</Link>
              : <span className="px-3 py-1.5 rounded-full bg-secondary font-semibold">1 day free on first open</span>}
          </div>
        )}
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-8">
        {agents.map((a, i) => {
          const Icon = AGENT_ICONS[a.key] || Mic;
          return (
            <motion.div key={a.key} initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.07 }}>
              <Link to={`/coaches/${a.key}`} data-testid={`coach-card-${a.key}`}
                className="group block rounded-2xl bg-card border border-border p-6 hover:shadow-lg hover:-translate-y-1 transition-all h-full">
                <div className="flex items-start justify-between">
                  <div className="h-12 w-12 rounded-xl emerald-surface grid place-items-center"><Icon className="h-6 w-6 text-white" /></div>
                  {a.voice && <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-accent text-accent-foreground">VOICE READY</span>}
                </div>
                <h3 className="mt-4 font-semibold text-lg">{a.name}</h3>
                <p className="text-sm text-primary font-medium">{a.tagline}</p>
                <p className="text-sm text-muted-foreground mt-2 leading-relaxed">{a.description}</p>
                <div className="mt-4 flex flex-wrap gap-1.5">
                  {a.starters.slice(0, 2).map((s) => <span key={s} className="text-[11px] px-2 py-1 rounded-full bg-secondary text-muted-foreground">{s}</span>)}
                </div>
                <div className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-primary">Open coach <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" /></div>
              </Link>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
